interface ActionButtonsProps {
  children: React.ReactNode;
}

export default function ActionButtons({ children }: ActionButtonsProps): JSX.Element | null {
  return <div className="d-flex flex-row justify-content-around">{children}</div>;
}
